/* istanbul ignore file */
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';
import { useArtifactStorageId } from 'domain/documents/artifactStorage/shared/useArtifactStorageId';
import { useArtifactStorageUrl } from 'domain/shared/artifactStorage';

const ViewArtifactStoragePageMenu = () => {
  const id = useArtifactStorageId();
  const { getSingleEntityUrl } = useArtifactStorageUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} exact />
    </SidebarStickyMenu>
  );
};

export default ViewArtifactStoragePageMenu;
